import React, { useState, useEffect, useCallback } from 'react';
import { format, subDays } from 'date-fns';
import ReportLayout, { ReportTable, usePagination, exportCSV, fmtId } from './ReportLayout';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import clsx from 'clsx';

const COLS = [
  { key:'staff_id',          label:'Staff ID',          render: fmtId },
  { key:'staff_name',        label:'Staff Name',       render: v => <span className="text-primary-600 font-medium">{v||'–'}</span> },
  { key:'_team',             label:'Team',             render: () => '–' },
  { key:'_facility',         label:'Facility',         render: () => '–' },
  { key:'pay_group',         label:'Pay Group' },
  { key:'contracted_hours',  label:'Contracted ...', render: v => v != null ? v : '–' },
  { key:'scheduled_hours',   label:'Scheduled H...' },
  { key:'weekly_hours',      label:'Weekly Hours' },
  { key:'hours_variance',    label:'Hours Variance', render: v => (
    <span className={clsx('font-bold', v > 0 ? 'text-red-500' : v < 0 ? 'text-green-600' : 'text-slate-400')}>
      {v > 0 ? `+${v}` : v}
    </span>
  )},
  { key:'role',              label:'Role',    render: v => v ? <span className="capitalize">{v}</span> : '–' },
  { key:'employment_type',   label:'Employment...' },
];

export default function HumanCapitalVariance() {
  const [data, setData]         = useState([]);
  const [loading, setLoading]   = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [startDate, setStart]   = useState(format(subDays(new Date(), 30), 'yyyy-MM-dd'));
  const [endDate, setEnd]       = useState(format(new Date(), 'yyyy-MM-dd'));

  const pagination = usePagination(data);

  const load = useCallback(() => {
    setLoading(true);
    api.get(`/reports/human-capital?start_date=${startDate}&end_date=${endDate}`)
      .then(r => { setData(r.data || []); pagination.reset(); })
      .catch(() => toast.error('Failed to load'))
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  useEffect(() => { load(); }, [load]);

  const chips = [{ label:'Date Range', value:`${startDate} - ${endDate}`, onRemove: null }];

  return (
    <ReportLayout
      title="Human Capital Variance"
      data={data} filename="human_capital_variance"
      columns={COLS}
      activeChips={chips}
      showFiltersPanel={showFilters}
      onToggleFilters={() => setShowFilters(v => !v)}
      filters={
        <div className="flex flex-wrap gap-4">
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">Start Date</label>
            <input type="date" value={startDate} onChange={e => setStart(e.target.value)} className="input-field !w-auto text-sm"/></div>
          <div><label className="block text-xs font-semibold text-slate-500 mb-1">End Date</label>
            <input type="date" value={endDate} onChange={e => setEnd(e.target.value)} className="input-field !w-auto text-sm"/></div>
          <div className="flex items-end">
            <button onClick={load} className="btn-primary text-sm px-4 py-2">Apply</button>
          </div>
        </div>
      }
    >
      <ReportTable columns={COLS} data={data} loading={loading} pagination={pagination}/>
    </ReportLayout>
  );
}
